import { render, staticRenderFns } from "./IconGripVertical.vue?vue&type=template&id=c3b7f390&"
import script from "./IconGripVertical.vue?vue&type=script&lang=ts&"
export * from "./IconGripVertical.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports